<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        @if (vm.havePrizesBeenAwarded) {
            <div class="results">
                <ds-card
                    class="mt-4 achieved position-relative ph-container-bg-w-marker"
                    [elevated]="dsComponents?.dsCardStatic?.elevated"
                    [variant]="dsComponents?.dsCardStatic?.variant">
                    @if (vm.currentlyAchievedText) {
                        <div class="achieved-header">{{ vm.currentlyAchievedText }}</div>
                        @if (!vm.showCheckButton) {
                            <div class="achieved-header-desc">{{ vm.commonContentMessages.prizescreditinend }}</div>
                        }
                    }
                    <tp-results-prize-group [showCheckButton]="vm.showCheckButton" [resultsContent]="vm.resultsContent"></tp-results-prize-group>
                </ds-card>
            </div>
        } @else {
            <ng-container *ngrxLet="vm$ as vm">
                @if (vm) {
                    <div>
                        @if (vm.slabType) {
                            <div>
                                <ng-container *ngrxLet="isMyProgressDisabled$ as isMyProgressDisabled">
                                    <no-prize [isDisabled]="isMyProgressDisabled"></no-prize>
                                </ng-container>
                            </div>
                        }
                    </div>
                }
            </ng-container>
        }
    }
</ng-container>
